import { useState } from "react";

import Footer from "./components/footer"
import Grid from "./components/grid";
import Nav from "./components/nav"
import Search from "./components/search";

const App = () => {
    const [search, setSearch] = useState();

    return (
        <div>
            <Nav />
            <Search setSearch={setSearch} />
            <Grid search={search} />
            <Footer />
        </div>
    );
}

export default App;